'use strict';

var React = require('react'),
    ContextMenu = require('../molecules/ContextMenu'),
    UserStore = require('../stores/UserStore'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    Link = require('../atoms/Link'),
    Counter = require('../atoms/Counter'),
    ModalActionCreators = require('../actions/ModalActionCreators'),
    AlertActionCreators = require('../actions/AlertActionCreators'),
    ModalTypes = require('../constants/ModalTypes'),
    AlertTypes = require('../constants/AlertTypes'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    SidebarTypes = require('../constants/SidebarTypes'),
    SidebarActionCreators = require('../actions/SidebarActionCreators');

var UserProfileContextMenu = React.createClass({
  mixins: [createStoreMixin(UserStore), PureRenderMixin],

  propTypes: {
    userId: React.PropTypes.number.isRequired,
    anchorRect: React.PropTypes.object.isRequired
  },

  getStateFromStores(props) {
    return {
      user: UserStore.get(props.userId)
    };
  },

  componentWillReceiveProps(newProps) {
    if (newProps.userId !== this.props.userId) {
      this.setState(this.getStateFromStores(newProps));
    }
  },

  render() {
    const { user } = this.state;

    return (
      <ContextMenu anchorRect={this.props.anchorRect}>
        <Link propagateClick
              to='user'
              params={{userId: user.id}}
              context='ContextMenu'
              underline='never'
              bold>
              My Profile
        </Link>
        <Link propagateClick
              onClick={this.handleDraftsClick}
              context='ContextMenu'
              underline='never'>
              My Drafts
              {' '}
              {user.draftCount > 0 &&
                <Counter count={user.draftCount} />
              }
        </Link>

        <ContextMenu.Separator />

        <Link propagateClick
              onClick={this.handleInviteFriendsClick}
              context='ContextMenu'
              underline='never'>
              Invite Friends
        </Link>

        <Link propagateClick
              onClick={this.handleSettingsClick}
              context='ContextMenu'
              underline='never'>
              Settings
        </Link>
        <Link propagateClick
              onClick={this.handleFeedbackClick}
              context='ContextMenu'
              underline='never'>
              Send Feedback
        </Link>
        <Link propagateClick
              onClick={this.handleLogoutClick}
              context='ContextMenu'
              underline='never'>
              Log Out
        </Link>
      </ContextMenu>
    );
  },

  handleLogoutClick() {
    AlertActionCreators.showAlert(AlertTypes.LOGOUT);
  },

  handleSettingsClick() {
    ModalActionCreators.showModal(ModalTypes.SETTINGS);
  },

  handleFeedbackClick() {
    ModalActionCreators.showModal(ModalTypes.FEEDBACK);
  },

  handleInviteFriendsClick() {
    ModalActionCreators.showModal(ModalTypes.SEND_INVITE);
  },

  handleDraftsClick() {
    SidebarActionCreators.showSidebar(SidebarTypes.DRAFTS);
  }
});

module.exports = UserProfileContextMenu;



/** WEBPACK FOOTER **
 ** ./contextMenus/UserProfileContextMenu.jsx
 **/